// src/components/ReportPDF.js
import React, { useEffect, useState } from "react";

import MonthlyReportServices from "../../../../services/COOPServices/MonthlyReportServices/MonthlyReportServices";
import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: {
    padding: 20,
  },
  table: {
    display: "table",
    width: "100%",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#000",
    borderCollapse: "collapse",
  },
  tableRow: {
    display: "table-row",
  },
  tableCell: {
    display: "table-cell",
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#000",
    padding: 8,
    textAlign: "center",
  },
  tableHeader: {
    backgroundColor: "#f2f2f2",
    fontWeight: "bold",
  },
});

const ReportPDF = ({
  id,
  headings,
  subHeadingGroups,
  debitTotal,
  creditTotal,
  isVisible,
}) => {
  const [report, setReport] = useState("");
  console.log("id in report pdf", id);

  const fetchData = async () => {
    try {
      const response = await MonthlyReportServices.getReportListById(id);
      console.log("response", response);
      setReport(response);
    } catch (error) {
      console.log("Error fetching report", error);
      console.log("Error fetching monthly report by id ");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  console.log("report name", report?.reportType?.name);

  return (
    <Document>
      <Page style={styles.page}>
        <View>
          <Text style={{ fontSize: 24, marginBottom: 10 }}>Report Detail</Text>
          <Text style={{ fontSize: 12, marginBottom: 20 }}>
            {report?.reportType?.name}
          </Text>
        </View>
      </Page>
    </Document>
  );
};

export default ReportPDF;
